import projects from '../assets/projects_data.json'
import '../assets/projectList.css'
import GamishHeader from './GamishHeader'
import Sparkles from './Sparkles'
import { skills_icons } from '../utils/icons'

const ProjectListGamish: React.FC = () => {
    return (
        <section className='projectlist projectlist_wrapper'>
            <Sparkles count={30} maxSize={2}/>
            <GamishHeader/>
                <ul className='section-wrapper'>
                    {projects.gamish.map((project, projectIndex) => (
                        <li key={projectIndex} className="">
                            <div className="card">
                                <a href={`/projects/gamish/id/${projectIndex}`} className="card-link"></a>
                                <img src={project.thumbnail} alt="" className="image" />
                                <div className="text-wrapper">
                                    <h2 className="title">{project.title}</h2>
                                    <div className="skills">
                                        {project.skills.map((skill, skillIndex) => (
                                            <span key={skillIndex}>{(skills_icons)[skill] || skill}</span>
                                        ))}
                                    </div>
                                    {/* <div className="details-wrapper">
                                        <p className="description">{project.short_description}</p>
                                    </div> */}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
        </section>
    )
}

export default ProjectListGamish